import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ExcalidrawLogo-icon"
  >
    <path
      d="M10.3 23.4 C13.3 27.8 17.3 27.8 20 23.75 C22.7 19.7 26.6 15.6 30.2 18.3"
      stroke="currentColor"
      strokeWidth="3.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="11.7" cy="16.1" r="1.6" fill="currentColor" />
  </svg>
);

const LogoText = () => (
  <svg
    viewBox="0 0 280 55"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="ExcalidrawLogo-text"
  >
    <text
      x="0"
      y="42"
      fill="currentColor"
      fontFamily="Assistant, Segoe UI, Helvetica, Arial, sans-serif"
      fontSize="48"
      fontWeight="700"
      letterSpacing="-1"
    >
      PizzarWeb
    </text>
  </svg>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
